/**
 * Protocol JSON Serialization — re-exported from @lokascript/intent
 */

export {
  toProtocolJSON,
  fromProtocolJSON,
  validateProtocolJSON,
  toEnvelopeJSON,
  fromEnvelopeJSON,
  isEnvelope,
} from '@lokascript/intent';
